<template>
    <table>
        <thead>
            <tr>
                <th>Time</th>
                <th>Tournament</th>
                <th>Event</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="event in upcomingEvent" :key="event.fixtureID">
                <td class="bold">{{ getTime(new Date(event.startTime)) }}</td>
                <td>{{ event.tournamentName }}</td>
                <td>{{ event.eventName }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import upcomingEventsApi from '../api/upcomingEvents'
    import { HubConnection } from "@aspnet/signalr";

    export default {
        name: 'UpcomingEvents',
        data() {
            return {
                upcomingEvent: null,
            }
        },
        props: {
            sport: String,
            eventName: String,
            startTime: String,
            connection: HubConnection,
        },

        watch: {
            sport: function (newSport, oldSport) {

                if (newSport !== oldSport) {

                    this.getUpcomingEvents(newSport);
                    if (this.connection) {
                        if (oldSport != '') {
                            this.connection.off(oldSport + "_upcoming_remove")
                            this.connection.off(oldSport + "_upcoming_add")
                        }

                        this.connection.on(newSport + "_upcoming_remove", (value) => {
                            console.log("Hub connection: " + newSport);
                            console.log('remove upcoming hub data: ' + value);
                            this.removeUpcomingEvent(JSON.parse(value.fixtureID));
                        });
                        this.connection.on(newSport + "_upcoming_add", (value) => {
                            console.log("Hub connection Add: " + newSport);
                            console.log('add upcoming hub data: ' + value);
                            this.addUpcomingEvent(JSON.parse(value));
                        });
                    }
                }
            },
        },

        methods: {
            getTime(date) {
                var hours = date.getHours();
                var mins = date.getMinutes();
                if (mins <= 9)
                    mins = '0' + mins
                return hours + ':' + mins
            },
            getUpcomingEvents(sport) {
                upcomingEventsApi.getUpcomingEvents(sport)
                    .then(data => {
                        this.upcomingEvent = data.responseObject;
                    })
            },
            addUpcomingEvent(newEvent) {
                var found = false
                for (let event in this.upcomingEvent) {
                    if (this.upcomingEvent[event].fixtureID == newEvent.FixtureID) {
                        found = true;
                    }
                }
                if (!found) {
                    this.upcomingEvent.push(newEvent);
                }
            },
            removeUpcomingEvent(removeId) {
                var counter = 0;
                for (let eventIndex in this.upcomingEvent) {
                    counter++;
                    if (this.upcomingEvent[eventIndex].fixtureID === removeId) {
                        console.log(counter + '||' + eventIndex);
                        break;
                    }
                }
                this.upcomingEvent.splice(counter, 1);

            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .odd {
        color: gold;
    }

    .bold {
        font-weight: 700;
        padding-right: 10px;
    }

    table {
        width: 100%;
        color: #FFFFFF;
        overflow-wrap: break-word;
    }

    th {
        color: gold;
        border-bottom: 2px solid #2b2b2b;
    }

    th, td {
        text-align: left;
        padding: 4px;
        font-size: 12px !important;
        padding-bottom: 10px !important;
    }

    @media only screen and (max-width: 768px), (min-device-width: 768px) and (max-device-width: 1024px) {

        table, thead, tbody, th, td, tr {
            display: block;
        }

            thead tr {
                position: absolute;
                top: -9999px;
                left: -9999px;
            }

        tr {
            margin: 0 0 2rem 0;
        }

        td {
            border: none;
            border-bottom: 1px solid #2b2b2b;
            position: relative;
            padding-left: 50%;
        }

            td:before {
                position: absolute;
                color: gold !important;
                left: 6px;
                width: 45%;
                font-weight: 700;
                padding-right: 10px;
                white-space: nowrap;
            }

            td:nth-of-type(1):before {
                content: "Time";
            }

            td:nth-of-type(2):before {
                content: "Tournament";
            }

            td:nth-of-type(3):before {
                content: "Event";
            }
    }
</style>
